<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Update Vehicle Model'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '600px' }"
        (onHide)="close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-tag"></p-inputicon>
                <input
                        pInputText
                        id="modelSeries"
                        [(ngModel)]="vehicleModel.modelSeries"
                        autocomplete="off"
                        class="w-full"
                />
            </p-iconfield>
            <label for="modelSeries">Model Series <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-info-circle"></p-inputicon>
                <input
                        pInputText
                        id="label"
                        [(ngModel)]="vehicleModel.label"
                        autocomplete="off"
                        class="w-full"
                />
            </p-iconfield>
            <label for="label">Label <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    [options]="carClasses"
                    [(ngModel)]="vehicleModel.carClassId"
                    optionLabel="label"
                    optionValue="id"
                    id="carClass"
                    class="w-full"
                    placeholder="Select Car Class"
                    filter
                    appendTo="body">
            </p-select>
            <label for="carClass">Car Class <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    [options]="bodyTypes"
                    [(ngModel)]="vehicleModel.bodyTypeId"
                    optionLabel="label"
                    optionValue="id"
                    id="bodyType"
                    class="w-full"
                    placeholder="Select Body Type"
                    filter
                    appendTo="body">
            </p-select>
            <label for="bodyType">Body Type <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    [options]="brands"
                    [(ngModel)]="vehicleModel.brandId"
                    optionLabel="label"
                    optionValue="id"
                    id="brand"
                    class="w-full"
                    placeholder="Select Brand"
                    filter
                    appendTo="body">
            </p-select>
            <label for="brand">Brand <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <app-select-or-upload-media [(selectedMedia)]="this.media"></app-select-or-upload-media>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>


    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="updateVehicleModel()"
                [loading]="loading"
        ></p-button>
    </div>
</p-dialog>
